import { create } from 'zustand'

interface NotepadState {
  content: string
  filename: string

  // Actions
  setContent: (content: string) => void
  appendContent: (content: string) => void
  setFilename: (filename: string) => void
  clear: () => void
}

const defaultContent = `Welcome to Notepad
==================

This is a simple text editor for PersonaOS.

You can use this to:
- Write notes
- Draft messages
- Edit text files

---
PERSONA SCIENCE
Persistent Identity Intelligence

Contact: contact@personascience.com
`

export const useNotepadStore = create<NotepadState>()((set, get) => ({
  content: defaultContent,
  filename: 'untitled.txt',

  setContent: (content: string) => set({ content }),

  appendContent: (content: string) => set((state) => ({
    content: state.content + '\n\n' + content
  })),

  setFilename: (filename: string) => set({ filename }),

  clear: () => set({ content: '', filename: 'untitled.txt' }),
}))
